import { render, staticRenderFns } from "./TaggingServices.vue?vue&type=template&id=5b1fb27c&scoped=true"
import script from "./TaggingServices.vue?vue&type=script&lang=ts"
export * from "./TaggingServices.vue?vue&type=script&lang=ts"
import style0 from "./TaggingServices.vue?vue&type=style&index=0&id=5b1fb27c&prod&lang=sass&scoped=true"
import style1 from "./TaggingServices.vue?vue&type=style&index=1&id=5b1fb27c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fb27c",
  null
  
)

export default component.exports